import { useModal } from "../../../../utils/ModalContext";
import { useEffect, useState } from "react";
import { FaDiscord, FaWallet } from "react-icons/fa";
import { MdNotes } from "react-icons/md";
import Button from "../../../../common/button";
import NavWrapper from "./Header.style";
import MobileMenu from "../mobileMenu/MobileMenu";
import logo from "../../../../assets/images/mint-logo.gif";

import {
  isWalletConnected,
  disconnectWallet,
} from "../../../../lib/metamaskhandler";
import { isMobile } from "react-device-detect";

const Header = () => {
  const { walletModalHandle, setConnect } = useModal();
  const [isMobileMenu, setMobileMenu] = useState(false);

  const handleMobileMenu = () => {
    setMobileMenu(!isMobileMenu);
  };

  const handleMetamaskDisconnect = async (e) => {
    e.preventDefault();
    setConnect(false);
    disconnectWallet();
    window.location.reload();
  };

  useEffect(() => {
    const header = document.getElementById("navbar");
    const handleScroll = window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });

    return () => {
      window.removeEventListener("sticky", handleScroll);
    };
  }, []);

  return (
    <>
      <NavWrapper className="bithu_header" id="navbar">
        <div className="container">
          {/* Main Menu Start */}
          <div className="bithu_menu_sect">
            <div className="bithu_menu_left_sect">
              <div className="logo">
                <a href="/">
                  <img src={logo} alt="bithu nft logo" />
                </a>
              </div>
            </div>
            <div className="bithu_menu_right_sect bithu_v1_menu_right_sect">
              <div className="bithu_menu_list">
                <ul>
                  <li>
                    <a href="/">Season 1</a>
                  </li>
                  {/* <li>
                    <a href="/free-mint">Free Mint</a>
                  </li> */}
                  <li>
                    <a href="/faq">FAQ</a>
                  </li>
                </ul>
              </div>
              <div className="bithu_menu_btns">
                <button className="menu_btn" onClick={() => handleMobileMenu()}>
                  <MdNotes />
                </button>
                {!isWalletConnected() ? (
                  <Button
                    sm
                    variant="hovered"
                    className="connect_btn"
                    onClick={() => walletModalHandle()}
                  >
                    <FaWallet />
                    Connect
                  </Button>
                ) : (
                  <Button
                    sm
                    variant="hovered"
                    className="connect_btn"
                    onClick={(e) => handleMetamaskDisconnect(e)}
                  >
                    <FaWallet />
                    Disconnect
                  </Button>
                )}
              </div>
            </div>
          </div>
          {/* <!-- Main Menu END --> */}
        </div>
      </NavWrapper>
      {isMobileMenu && <MobileMenu mobileMenuhandle={handleMobileMenu} />}
    </>
  );
};

export default Header;
